<template>
  <section class="organism-pricing-preview">
    <h1 class="main-title">Pricing that scales with your needs</h1>
    <p class="vision-description">
      Simple subscription designed for professionals.
    </p>
    <div v-if="plans.length > 0" class="plans-container">
      <div
        v-for="plan in plans"
        :key="plan.id"
        class="plan-card"
        :class="{ 'plan-card-popular': plan.id === 'm' }"
      >
        <div
          v-if="plan.badge"
          class="plan-badge"
          :class="{ 'plan-badge-popular': plan.id === 'm' }"
        >
          {{ plan.badge }}
        </div>
        <h2 class="plan-name">{{ plan.name }}</h2>
        <div class="plan-price">
          <span class="currency">$</span>
          <span class="amount">{{ plan.price }}</span>
          <span class="period">/month</span>
        </div>
        <p class="plan-description">{{ plan.description }}</p>
        <div class="plan-features">
          <div
            v-for="(feature, idx) in plan.features"
            :key="idx"
            class="feature-item"
          >
            <vue-feather
              type="check"
              size="18"
              :style="{
                color: plan.id === 'm' ? '#fff' : '#000',
              }"
            />
            <span>{{ feature }}</span>
          </div>
        </div>
        <button
          class="subscribe-btn"
          :class="{ 'subscribe-btn-popular': plan.id === 'm' }"
          @click="handleSubscribe"
        >
          Subscribe
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { subscriptionService } from "@/services/subscriptionService";

export default {
  name: "PricingPreview",
  data() {
    return {
      plans: [],
    };
  },
  mounted() {
    this.loadPlans();
  },
  methods: {
    loadPlans() {
      // Use static subscription data directly without API calls
      const subscriptionData = subscriptionService.getSubscriptionData();
      // Convert object to array format
      this.plans = Object.values(subscriptionData);
    },
    handleSubscribe() {
      this.$router.push("/subscriptions");
    },
  },
};
</script>

<style scoped>
.organism-pricing-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10rem 5rem;
  background-color: #fff;
}

.main-title {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #000;
  font-weight: bold;
}

.vision-description {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  color: #7e7e7e;
  width: 75%;
  max-width: 800px;
  margin-bottom: 4rem;
}

.plans-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.plan-card {
  background: #fff;
  border-radius: 24px;
  padding: 2rem;
  border: 2px solid #f2f5f9;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.plan-card:hover {
  border-color: #e5e7eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.plan-card-popular {
  background: #000;
  border-color: #333;
}

.plan-card-popular:hover {
  border-color: #444;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1);
}

.plan-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #000;
  color: white;
  padding: 4px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

.plan-badge-popular {
  background: #10b981;
  color: white;
}

.plan-name {
  font-size: 1.5rem;
  color: #000;
  margin-bottom: 16px;
  font-weight: 600;
  text-align: left;
}

.plan-card-popular .plan-name {
  color: #fff;
}

.plan-price {
  font-size: 2.5rem;
  color: #000;
  margin-bottom: 8px;
  text-align: left;
}

.plan-card-popular .plan-price {
  color: #fff;
}

.currency {
  font-size: 1.5rem;
  vertical-align: top;
}

.amount {
  font-weight: 300;
}

.period {
  font-size: 1rem;
  color: #6b7280;
  vertical-align: baseline;
}

.plan-card-popular .period {
  color: #9ca3af;
}

.plan-description {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 8rem;
  line-height: 1.5;
  text-align: left;
}

.plan-card-popular .plan-description {
  color: #9ca3af;
}

.plan-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #111827;
}

.plan-card-popular .feature-item {
  color: #fff;
}

.subscribe-btn {
  width: 100%;
  padding: 14px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: auto;
}

.subscribe-btn:hover {
  background-color: #333;
}

.subscribe-btn-popular {
  background-color: #fff;
  color: #000;
}

.subscribe-btn-popular:hover {
  background-color: #f3f4f6;
}

@media (max-width: 1200px) {
  .plans-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .organism-pricing-preview {
    padding: 5rem 1rem;
  }

  .main-title {
    font-size: 2rem;
    font-weight: bold;
    width: 80%;
  }

  .vision-description {
    width: 100%;
    font-size: 1rem;
    margin-bottom: 3rem;
  }

  .plans-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 500px;
  }

  .plan-card {
    padding: 1.5rem;
  }

  .plan-price {
    font-size: 2rem;
  }
}
</style>
